module.exports = __webpack_public_path__ + "e3420db7aee7db290b8efd98b58ff6d6.svg";